import {
  getUseCaseBySlug,
  type AgentUseCase,
} from "@/content/agent-use-cases";
import type { IndustryKey, IndustryPage } from "./types";
import { logisticsIndustry } from "./logistics";
import { retailIndustry } from "./retail";

// Launch set — extend this array to add an industry page.
export const industryPages: IndustryPage[] = [
  logisticsIndustry,
  retailIndustry,
];

export function getIndustryByKey(key: IndustryKey): IndustryPage | undefined {
  return industryPages.find((i) => i.key === key);
}

export function getIndustryByRoute(route: string): IndustryPage | undefined {
  return industryPages.find((i) => i.route === route);
}

// The use cases featured on an industry page, in the industry's declared order.
export function getUseCasesForIndustry(page: IndustryPage): AgentUseCase[] {
  return page.useCaseSlugs
    .map((slug) => getUseCaseBySlug(slug))
    .filter((u): u is AgentUseCase => Boolean(u));
}

// Inverse: which industry pages feature a given use-case slug (drives the card chips).
export function getIndustriesForUseCase(slug: string): IndustryPage[] {
  return industryPages.filter((i) => i.useCaseSlugs.includes(slug));
}

export type { IndustryPage, IndustryKey };
